import styled from "styled-components";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
  MDBCardTitle,
} from "mdb-react-ui-kit";
import { Row } from "../App.styles";
import { Alert, Refresher, SidebarLayout, withPlaceholder } from "../common";
import { useInfinityChallengeStream } from "./Monitor.state";
import Answer from "./Answer";
import LeaderboardWidget from "./LeaderboardWidget";
import MediaOverlay from "./MediaOverlay";
import MonitorPlaceholder from "./MonitorPlaceholder";
import InfiniteList from '../common/InfiniteList'
import { usePageListeners } from "../common/Refresher.state";
import ROUTE_PATTERNS from "../consts/routes";

export const PanelFooter = styled.div`
  color: #a0a0a0;
  font-size: 0.8125rem;
  margin-bottom: 2rem;
  padding: 10px 15px;
  margin-top: 10px;
`;

const ChallengeStream = () => {
  const { t } = useTranslation();
  const query = useInfinityChallengeStream();
  const { data } = query
  const answers = useMemo(() => data ? data.pages.flatMap((page) => page?.answers) : [], [data]);
  const game = data?.pages[0].game;
  const [overlayId, setOverlayId] = useState();

  const task_name = answers.length ? answers[0].task.name : "";
  const answerIds = useMemo(() => answers.map(answer => answer.id), [answers]);
  const listeners = usePageListeners(ROUTE_PATTERNS.TASKS_STREAM, { answerIds });
  return (
    <>
      <Row>
        <SidebarLayout
          panel={(
            <>
              <MDBCard>
                <MDBCardHeader>
                  <MDBCardTitle>{t('Submissions')}</MDBCardTitle>
                  <MDBCardBody>
                    <p dangerouslySetInnerHTML={{__html: t(`Your completed challenges are submitted instantly to a live
                      stream and categorized for easy viewing. The live stream is
                      available on Web and inside the app.`)}} />
                  </MDBCardBody>
                </MDBCardHeader>
              </MDBCard>
              <LeaderboardWidget />
            </>
          )}
        >
            <InfiniteList
                name="answers"
                query={query}
                noContent={<Alert color="warning">{t('There are no submissions to review.')}</Alert>}
                renderItem={({ ...item }) => {
                    return (
                        <Answer
                            {...item}
                            game={game}
                            onFullscreen={setOverlayId}
                        />
                    )
                }}
            >
                {
                    task_name !== "" 
                        ? (
                            <Alert color="info">
                                {t('Real Time Team Activity for')} {task_name}
                            </Alert>
                        ) 
                        : null
                }
            </InfiniteList>
        </SidebarLayout>
      </Row>
      {overlayId && (
        <MediaOverlay
          {...answers.find((answer) => answer.id === overlayId)}
          onClick={() => setOverlayId(undefined)}
        />
      )}
      <Refresher listeners={listeners} />
    </>
  );
};

export default withPlaceholder(ChallengeStream, MonitorPlaceholder);
